/**
 * Returns the date format pattern for the given locale and formatting options
 */
export function getLocaleDateFormatPattern(
  locale?: string,
  options?: Intl.DateTimeFormatOptions
): string {
  const formattedParts = new Intl.DateTimeFormat(
    locale,
    options
  ).formatToParts();

  return formattedParts
    .map(part => {
      switch (part.type) {
        case 'day':
          return 'DD';
        case 'month':
          return 'MM';
        case 'year':
          return 'YYYY';
        default:
          return part.value;
      }
    })
    .join('');
}

/**
 * Check if Javascript date object is an "invalid date"
 */
export function isValidDate(date: Date | null): boolean {
  // @ts-ignore: 'Date' is not assignable to parameter of type 'number'
  return date instanceof Date && !isNaN(date);
}
